module.exports = __webpack_public_path__ + "img/watermelon.a99fbfbb.svg";